// assets/js/lightbox.js

export function initLightbox() {
  const overlay = document.querySelector('.js-ref-lightbox');
  if (!overlay) return;

  const imgEl   = overlay.querySelector('.js-ref-lightbox-img');
  const closeEls = overlay.querySelectorAll('.js-ref-lightbox-close');
  const prevBtn = overlay.querySelector('.js-ref-lightbox-prev');
  const nextBtn = overlay.querySelector('.js-ref-lightbox-next');

  let currentSlides = [];
  let currentIndex  = -1;

  function updateImage() {
    if (!currentSlides.length || currentIndex < 0) return;
    const img = currentSlides[currentIndex];

    imgEl.src = img.getAttribute('src');
    imgEl.alt = img.getAttribute('alt') || '';
  }

  function openFromTrigger(trigger) {
    const card = trigger.closest('.js-ref-card');
    if (!card) return;

    currentSlides = Array.from(
      card.querySelectorAll('.js-ref-lightbox-trigger img')
    );

    const clickedImg = trigger.querySelector('img');
    currentIndex = currentSlides.indexOf(clickedImg);
    if (currentIndex < 0) currentIndex = 0;

    updateImage();
    overlay.classList.add('is-open');
    document.documentElement.classList.add('is-lightbox-open');
  }

  function close() {
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('is-lightbox-open');
    currentSlides = [];
    currentIndex = -1;
  }

  function showNext(step) {
    if (!currentSlides.length) return;
    const total = currentSlides.length;
    currentIndex = (currentIndex + step + total) % total;
    updateImage();
  }

  // Délégation de clic sur les vignettes
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.js-ref-lightbox-trigger');
    if (!trigger) return;
    e.preventDefault();
    openFromTrigger(trigger);
  });

  // Fermer : bouton X + clic sur backdrop
  closeEls.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      close();
    });
  });

  overlay.addEventListener('click', (e) => {
    // sécurité si on clique en dehors du dialog
    if (e.target === overlay) {
      close();
    }
  });

  // Navigation flèches
  if (prevBtn) {
    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      showNext(-1);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      showNext(1);
    });
  }

  // Clavier : Esc / ← →
  document.addEventListener('keydown', (e) => {
    if (!overlay.classList.contains('is-open')) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      close();
    }
    if (e.key === 'ArrowRight') {
      e.preventDefault();
      showNext(1);
    }
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      showNext(-1);
    }
  });
}
